var learnBtn = document.querySelector('.learn_more_btn');

if(learnBtn){
learnBtn.addEventListener('click',function(){
   document.querySelector('.thb-product-detail shopify-payment-terms').shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot.querySelector('#prequalAmountRowWrapper').querySelector('#shopify-installments-cta').click();
});
}

$(document).ready(function(){
  if (matchMedia('only screen and (max-width: 1068px)').matches) {
    let carousel = document.querySelector('.product_slider');
      if (carousel) {
          var flkty = new Flickity(carousel, {
              wrapAround: true, 
              pageDots: false, 
          });
      
          var totalSlides = $(document).find('.flickity-slider .product-images__slide').length;
          $(document).find('.total-slides').text(totalSlides);
      
          flkty.on('select', function() {
              var slideIndex = flkty.selectedIndex + 1;
              $(document).find('.current-slide').text(slideIndex);
          });
      } 
  }
});

setInterval(function(){
  var inventoryText = $(document).find('.product-inventory-notice--wrapper').html();
  $(document).find('.inventory_content').html(inventoryText);
},1000);